"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInvoice = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var createInvoice = exports.createInvoice = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (apiUri, email, price) {
    var res = yield _axios.default.post("".concat(apiUri, "/bitpay/invoice"), {
      email,
      price
    });
    return yield res.data;
  });
  return function createInvoice(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();